module.exports = __webpack_public_path__ + "img/bg-mobile-head.1c931282.png";